import { useWindowDimensions } from 'src/hooks/useWindowDimensions';

export const useResponsive = () => {
  const { width } = useWindowDimensions();
  const isDesktop = width > 992;
  const isTablet = width > 480;
  return { isDesktop, isTablet };
};
